app.directive('hoverSwappableBackground', function ($document, $log) {
    return {
        restrict: 'A',
        scope: {
            config: '=hoverSwappableBackground'
        },
        link: function ($scope, $element) {
            var isHovering = false;
            var wasTouchTriggered = false;
            var preventDefaultClickAction = false;

            var onStateChange = function (isInHoveringState, isTouchTriggered) {
                if (isTouchTriggered && $scope.config && $scope.config.disableTouch === true) {
                    return;
                }

                isHovering = isInHoveringState;
                wasTouchTriggered = isTouchTriggered;
                preventDefaultClickAction = wasTouchTriggered;

                updateBackgroundImage();
            };

            var updateBackgroundImage = function () {
                if (!$scope.config || !$scope.config.normal) {
                    $element.css('background-image', 'none');
                    return;
                }

                if ($scope.config.hover && isHovering) {
                    $element.css('background-image', 'url("' + $scope.config.hover + '")');
                    return;
                }

                $element.css('background-image', 'url("' + $scope.config.normal + '")');
            };

            $element.on('mouseenter', function ($event) {
                onStateChange(true, false);
            });

            $element.on('mouseleave', function ($event) {
                if (wasTouchTriggered === true) return;
                onStateChange(false, false);
            });

            $element.on('touchstart', function ($event) {
                if (!isHovering) {
                    $event.preventDefault();
                    onStateChange(true, true);
                } else {
                    onStateChange(false, true);
                }
            });

            $document.on('touchstart', function ($event) {
                if (isHovering && !$element.is($event.target)) {
                    onStateChange(false, true);
                }
            });

            $element.on('click', function ($event) {
                if ($scope.config && $scope.config.disableTouch === true) {
                    return;
                }

                if (preventDefaultClickAction) {
                    $event.preventDefault();
                    $event.stopPropagation();

                    preventDefaultClickAction = false;
                }
            });

            $scope.$watch('config', function () {
                updateBackgroundImage();
            }, true);
        }
    };
});